import React from 'react'
import styled from 'styled-components'
import { Droppable, Draggable } from 'react-beautiful-dnd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripLines, faTrashAlt } from "@fortawesome/free-solid-svg-icons";

const Container = styled.div`
    flex:2;    
    border: solid;
    border-color: darkgrey;
    border-radius: .5em;
    height: 100%;
    margin-left:10px;
    margin-right:10px;
    padding: 10px;
    overflow: scroll;
    display: flex;
    justify-content:center;
    align-items: center; 
    flex-direction: column;
`

const Stage = styled.div`
    width: 90%;
    display: flex;
    border: solid darkgrey;
    border-radius: .5em;
    margin: .5em;
    padding:.5em;
`

const Input = styled.div`
    width: 90%;
    display: flex;
    border: dashed darkgrey;
    border-radius: .5em;
    margin: .5em;
    padding:.5em;
`

const StageName = styled.h4`
    padding-left: 10px;
    padding-right: 10px;
`

const RemoveStage = styled.span`
    margin-right: 1em;
    margin-left: auto;
`

const DragHandle = styled.span``

const Heading = styled.h2`
    color: #aaa;
`



const BuildArea = ({ stages = [], input, output, removeStage = () => { } }) => {
    const displayPrompt = 0 === stages.length && !input && !output

    return (
        <Droppable droppableId='build-area'>
            {(provided) => (
                <Container ref={provided.innerRef} {...provided.droppableProps} >
                    {displayPrompt ? <Heading>Drop Parts Here</Heading> : null}
                    {input && <Input><StageName>{input.name}</StageName></Input>}
                    {stages.map((s, i) => {
                        return <Draggable key={i} draggableId={`stage-${s.name}-${i}`} index={i}>
                            {(provided) => (
                                <Stage ref={provided.innerRef} {...provided.draggableProps}>
                                    <DragHandle {...provided.dragHandleProps}><FontAwesomeIcon icon={faGripLines}/></DragHandle>
                                    <div>
                                        <StageName>{s.name}</StageName>
                                    </div>
                                    <RemoveStage onClick={removeStage(i)}><FontAwesomeIcon icon={faTrashAlt}/></RemoveStage>
                                </Stage>
                            )}
                        </Draggable>
                    })}
                    {output && <Input><StageName>{output.name}</StageName></Input>}
                </Container>

            )}
        </Droppable>
    )
}

export default BuildArea;
